import type { StrictTupleKey } from 'swr/_internal';
import useSWRImmutable from 'swr/immutable';
import { ComparableSubscription } from '~/models/subscription-comparison/ComparableSubscriptions';
import { getSubscriptionsForPartner } from './api';
import { comparableSubscriptionsStaticData } from './placeholderSubscriptionComparisonData';

export const useComparableSubscriptions = (partnerAlias: string, dwellingUnit: string) => {
  const cacheKey: StrictTupleKey = ['get-subscription', partnerAlias, dwellingUnit];

  return useSWRImmutable(cacheKey, async () => {
    const res = await getSubscriptionsForPartner(partnerAlias, dwellingUnit);
    return res.map((sub) => {
      const staticData = comparableSubscriptionsStaticData.filter((s) => s.subscriptionIccProductId === sub.subscriptionIccProductId)[0];
      const compSub: ComparableSubscription = {
        ...staticData,
        ...sub,
        discountPercentage: getDiscountPercentage(sub.originalPrice, sub.currentPrice),
        readMoreUrl: getReadMoreUrl(partnerAlias, sub.campaignUrl),
      };
      return compSub;
    });
  });
};

const getDiscountPercentage = (originalPrice: number, currentPrice: number) => {
  return Math.floor((1 - currentPrice / originalPrice) * 100);
};

const getReadMoreUrl = (partnerAlias: string, campaignUrl: string) => {
  // TODO: Should check if it's fiber in a better way
  // Best way would be by businessUnitId, but then we need to fetch partner data
  // in the API using SalesPartnerRegistry service (to get the bUnitId from Sanity)
  if (partnerAlias === 'kampanje') {
    return `https://www.rikstv.no/tv-pakker/${campaignUrl}`;
  }
  return `https://www.rikstv.no/rikstv-via-fiber/partner/${partnerAlias}/${campaignUrl}/`;
};
